// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&family=Roboto+Flex:opsz,wght@8..144,100;8..144,200;8..144,300;8..144,400;8..144,500;8..144,600;8..144,700;8..144,800;8..144,900;8..144,1000&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
  scroll-behavior: smooth;
}

body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
  background-color: white;
}

* {
  box-sizing: border-box;
}

*::after,
*::before {
  box-sizing: border-box;
}

::-webkit-file-upload-button {
  appearance: button;
  -webkit-appearance: button;
  font: inherit;
}

img,
picture,
video,
canvas,
svg {
  max-width: 100%;
}

ul,
ol {
  padding: 0;
  margin: 0;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  overflow-wrap: break-word;
  hyphens: auto;
  margin: 0;
}

button,
input,
select,
label {
  font-family: inherit;
  outline: none;
}

label {
  display: block;
}

button {
  cursor: pointer;
}

[type=button],
[type=reset],
[type=submit] {
  appearance: buttom;
  -webkit-appearance: button;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

hr {
  overflow: visible;
}

legend {
  box-sizing: border-box;
  color: inherit;
  white-space: normal;
}

#root {
  height: 100%;
  isolation: isolate;
}

.container {
  max-width: 1565px;
  padding-left: 24px;
  padding-right: 24px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}
@media (max-width: 540px) {
  .container {
    padding-left: 16px;
    padding-right: 16px;
  }
}

.page {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
}
.page main {
  flex: 1 1 auto;
}
.page header {
  z-index: 1;
}
.page footer {
  margin-top: auto;
}

.textarea-container {
  position: relative;
}

.textarea-container > div, .textarea-container > textarea {
  word-wrap: break-word; /* make sure the div and the textarea wrap words in the same way */
  box-sizing: border-box;
  padding: 2px;
  width: 100%;
}

.textarea-container > textarea {
  overflow: hidden;
  position: absolute;
  height: 100%;
}

.textarea-container > div {
  padding-bottom: 1.5em; /* A bit more than one additional line of text. */
  visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAEA;;EAEE,YAAA;EACA,uBAAA;AAAF;;AAEA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;EACA,mCAAA;EACA,8BAAA;EACA,uBAAA;AACF;;AACA;EACE,sBAAA;AAEF;;AAAA;;EAEE,sBAAA;AAGF;;AADA;EACE,kBAAA;EACA,0BAAA;EACA,aAAA;AAIF;;AAFA;;;;;EAKE,eAAA;AAKF;;AAHA;;EAEE,UAAA;EACA,SAAA;AAMF;;AAJA;;;;;;;EAOE,yBAAA;EACA,aAAA;EACA,SAAA;AAOF;;AALA;;;;EAIE,oBAAA;EACA,aAAA;AAQF;;AANA;EACE,cAAA;AASF;;AAPA;EACE,eAAA;AAUF;;AARA;;;EAGE,kBAAA;EACA,0BAAA;AAWF;;AATA;EACE,yBAAA;EACA,iBAAA;AAYF;;AAVA;EACE,iBAAA;AAaF;;AAVA;EACE,sBAAA;EACA,cAAA;EACA,mBAAA;AAaF;;AAXA;EACE,YAAA;EACA,kBAAA;AAcF;;AAXA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AAcF;AAbE;EAPF;IAQI,kBAAA;IACA,mBAAA;EAgBF;AACF;;AAdA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AAiBF;AAhBE;EACE,cAAA;AAkBJ;AAhBE;EACE,UAAA;AAkBJ;AAhBE;EACE,gBAAA;AAkBJ;;AAfA;EACE,kBAAA;AAkBF;;AAfA;EACE,qBAAA,EAAA,kEAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AAkBF;;AAfA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;AAkBF;;AAfA;EACE,qBAAA,EAAA,iDAAA;EACA,kBAAA;AAkBF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&family=Roboto+Flex:opsz,wght@8..144,100;8..144,200;8..144,300;8..144,400;8..144,500;8..144,600;8..144,700;8..144,800;8..144,900;8..144,1000&display=swap');\r\n\r\nhtml,\r\nbody {\r\n  height: 100%;\r\n  scroll-behavior: smooth;\r\n}\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  -webkit-font-smoothing: antialiased;\r\n  -webkit-text-size-adjust: 100%;\r\n  background-color: white;\r\n}\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n*::after,\r\n*::before {\r\n  box-sizing: border-box;\r\n}\r\n::-webkit-file-upload-button {\r\n  appearance: button;\r\n  -webkit-appearance: button;\r\n  font: inherit;\r\n}\r\nimg,\r\npicture,\r\nvideo,\r\ncanvas,\r\nsvg {\r\n  max-width: 100%;\r\n}\r\nul,\r\nol {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np {\r\n  overflow-wrap: break-word;\r\n  hyphens: auto;\r\n  margin: 0;\r\n}\r\nbutton,\r\ninput,\r\nselect,\r\nlabel {\r\n  font-family: inherit;\r\n  outline: none;\r\n}\r\nlabel {\r\n  display: block;\r\n}\r\nbutton {\r\n  cursor: pointer;\r\n}\r\n[type=\"button\"],\r\n[type=\"reset\"],\r\n[type=\"submit\"] {\r\n  appearance: buttom;\r\n  -webkit-appearance: button;\r\n}\r\ntable {\r\n  border-collapse: collapse;\r\n  border-spacing: 0;\r\n}\r\nhr {\r\n  overflow: visible;\r\n}\r\n\r\nlegend {\r\n  box-sizing: border-box;\r\n  color: inherit;\r\n  white-space: normal;\r\n}\r\n#root {\r\n  height: 100%;\r\n  isolation: isolate;\r\n}\r\n\r\n.container {\r\n  max-width: 1565px;\r\n  padding-left: 24px;\r\n  padding-right: 24px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  width: 100%;\r\n  @media (max-width: 540px) {\r\n    padding-left: 16px;\r\n    padding-right: 16px;\r\n  }\r\n}\r\n.page {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  main {\r\n    flex: 1 1 auto;\r\n  }\r\n  header {\r\n    z-index: 1;\r\n  }\r\n  footer {\r\n    margin-top: auto;\r\n  }\r\n}\r\n.textarea-container {\r\n  position: relative;\r\n}\r\n\r\n.textarea-container > div, .textarea-container > textarea {\r\n  word-wrap: break-word; /* make sure the div and the textarea wrap words in the same way */\r\n  box-sizing: border-box;\r\n  padding: 2px;\r\n  width: 100%;\r\n}\r\n\r\n.textarea-container > textarea {\r\n  overflow: hidden;\r\n  position: absolute;\r\n  height: 100%;\r\n}\r\n\r\n.textarea-container > div {\r\n  padding-bottom: 1.5em; /* A bit more than one additional line of text. */ \r\n  visibility: hidden;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
